/* @flow */
import React from 'react';
import dynamic from 'next/dynamic';
import { connect } from 'react-redux';
import Router from 'next/router';
// $FlowFixMe
import styled, { createGlobalStyle } from 'styled-components';
import AutoForm from 'react-auto-form';
import md5 from 'md5';
import {
  Input,
  Button,
  Safety,
  Checkbox,
  Modal,
  // $FlowFixMe
} from '@bijie/react-bnb';
import is from 'is_js';

import regrex from '../../utils/regrex';
import withI18n from '../../utils/withI18n';
import { getLabel } from '../../utils/i18n';
import { checkPasswordLevel, checkInput, isTrue } from '../../utils/validate';
import { getCommonUiLocales } from '../../utils/locales';
import { getLoginUrl } from '../../utils/urlUtils';

import API_PATH from '../../actions/actionsFactory/apiPath';
import { gwPost, gwGet } from '../../actions/actionsFactory/gwRequest';
import { setPostBody } from '../../actions/actionsFactory';
import { fetchUserAgentMessage } from '../../actions/actionsSet/account';
import FlexBox from '../FlexBox';
import urlConfig from '../../config/urls';
import AgentIdInfo from './AgentIdInfo';
import { fetchForbidenEmail } from '../../actions/actionsSet/common';


import Icon from '../Icon';

const { GET_COUNTRY_IP_RESTRICTED } = API_PATH;

const { InputShrink } = Input;

const {
  site: { terms: TERMS_URL },
} = urlConfig;

const { REGISTER_API_PATH } = API_PATH;

const GeeTest = dynamic(import('../../network/GeeTest'), {
  ssr: false,
  loading: () => null,
});

const GloablModalStyled = createGlobalStyle`
  .register-form-modal {
    .bnc-modal-open-wrapper{
      min-height:auto;
    }
  }
`;

const FormBox = styled.div`
  width: 100%;
  a,
  a:visited {
    color: ${({ theme }) => theme.highlight};
  }
  a:hover {
    text-decoration: underline;
  }
  .bnc-safety-wrapper {
    position: absolute;
    right: 0;
  }
`;

const FormItem = styled.div`
  width: 100%;
  position: relative;
  margin-bottom: 10px;
`;

const StyledLabel = styled.label`
  display: block;
  color: ${({ theme }) => theme.descriptionWord};
  .bnc-checkbox {
    vertical-align: middle;
    margin-right: 8px;
  }
  .bnc-checkbox-inner {
    border-color: ${({ theme }) => theme.checkBoxBorder};
  }
  input:checked + .bnc-checkbox-inner {
    border-color: ${({ theme }) => theme.highlight};
  }
`;

const FormItemHelp = styled.div`
  width: 100%;
  height: 24px;
  line-height: 24px;
  color: ${({ isError }) => (isError ? '#F23051' : '#48515D')};
`;

const SideBox = styled(FlexBox)`
  width: 100%;
`;

const NoUsLoginTip = styled.div`
  height: auto;
  overflow: hidden;
  text-align: left;
  > h3 {
    color: #212833;
    font-size: 18px;
    font-family: ${({ theme }) => theme.fontIBMMedium};
    margin: 0;
    padding: 0;
    > .iconfont {
      font-size: 18px;
      margin-right: 12px;
    }
  }
  > p {
    color: #48515d;
    padding: 20px 0 0 30px;
    margin: 0;
    font-size: 14px;
    font-family: ${({ theme }) => theme.fontIBMLight};
  }
`;

const mapStateToProps = ({ locale, refSwitchInfo, referralRate }) => ({
  locale,
  refSwitchInfo,
  referralRate,
});

type Props = {
  locale: string,
  i18n: Object,
  refSwitchInfo: Object,
  referralRate: string,
  fetchUserAgentMessage: Function,
};

type CaptType = {
  getValidate: Function,
  verify: Function,
};

type State = {
  email: string,
  emailError: string,
  password: string,
  passwordError: string,
  agentId: string,
  agentIdError: string,
  isAgree: boolean,
  isAgreeError: string,
  submiting: boolean,
  isAgent: boolean,
  ts: string,
  adBlock: string,
  pwdLevel: string,
  capt: CaptType,
  loadingGeetest: boolean,
  forbidenEmails: Array<string>,
};

export default
@connect(
  mapStateToProps,
  { fetchUserAgentMessage }
)
@withI18n
class RegisterForm extends React.Component<Props, State> {
  static defaultProps = {
    locale: 'en',
    i18n: {},
    refSwitchInfo: {},
    referralRate: '',
    fetchUserAgentMessage: () => {},
  };

  state = {
    email: '',
    emailError: '',
    password: '',
    passwordError: '',
    agentId: '',
    agentIdError: '',
    isAgree: false,
    isAgreeError: '',
    ts: '',
    adBlock: '',
    submiting: false,
    isAgent: false,
    pwdLevel: '',
    loadingGeetest: true,
    forbidenEmails: [],
    capt: {
      getValidate: (): Object => ({}),
      verify: () => {},
    },
  };

  loginUrl: string = getLoginUrl(this.props.locale);

  mybot = {
    sendCheckInfo: () => {},
  };

  componentDidMount() {
    // $FlowFixMe
    import('@binance/recaptcha').then(res => {
      const Bantibot = res.default;
      const { origin } = window.location;
      this.mybot = new Bantibot({
        biz_id: 'register',
        apiServer: origin,
      });
    });

    this._handleGetCountryIpResiricted();
    fetchForbidenEmail().then((data) => (this.setState({ forbidenEmails: data.data })));
  }

  _handleGetCountryIpResiricted = async () => {
    const { i18n } = this.props;
    try {
      const result = await gwGet(GET_COUNTRY_IP_RESTRICTED);
      const { success, data } = result;
      if (success) {
        if (data.restricted) {
          Modal.info({
            wrapClassName: 'register-form-modal',
            content: (
              <NoUsLoginTip>
                <h3>
                  <Icon type="prompt" color="#F0B90B" />
                  {getLabel('exchange-noUsRegister-modalTitle', i18n)}
                </h3>
                <p>{getLabel('exchange-noUsRegister-modalDesc', i18n)}</p>
              </NoUsLoginTip>
            ),
            okText: getLabel('exchange-modal-iUnderstood', i18n),
            onOk() {
              console.log('onOk');
            },
          });
        }
      }
    } catch (error) {
      throw error;
    }
  };

  _handleAgentIdInfo = (agentIdInfo: Object) => {
    const { ts, adBlock, agentId } = agentIdInfo;
    if (agentId?.length > 0) {
      this.props.fetchUserAgentMessage({
        agentCode: agentId,
      });
    }
    this.setState({
      ts,
      adBlock,
      agentId,
      isAgent: !!agentId,
    });
  };

  _handleGeetestReady = (capt: CaptType) => {
    this.setState({
      capt,
      loadingGeetest: false,
    });
  };

  _handleGeetestError = () => {};

  _handlerGeetestSuccess = async () => {
    const { i18n } = this.props;
    this.setState({ submiting: true });

    const {
      email, password, agentId, ts, adBlock, capt,
    } = this.state;

    // eslint-disabled-next-line
    const {
      geetest_challenge: geetestChallenge,
      geetest_seccode: geetestSecCode,
      geetest_validate: geetestValidate,
    } = capt.getValidate();

    const formatEmail = email.trim().toLowerCase();
    const params = setPostBody({
      // 使用新的邮件激活方式, 从激活邮件改为 code 码激活
      isNewRegistrationProcess: true,
      email: formatEmail,
      password: md5(password + formatEmail),
      agentId,
      ts,
      adBlock,
      validateCodeType: 'gt',
      geetestChallenge,
      geetestSecCode,
      geetestValidate,
    });

    try {
      const { locale } = this.props;
      const result = await gwPost(REGISTER_API_PATH, { locale, ...params }, null, false);
      if (result.success) {
        sessionStorage.setItem('registerEmail', formatEmail);
        Router.pushRoute(`/${locale}/email-verification`);
      } else if (result.message) {
        Modal.info({
          wrapClassName: 'register-form-modal',
          content: <p>{result.message}</p>,
          okText: getLabel('exchange-modal-iUnderstood', i18n),
        });
      }
      this.setState({
        submiting: false,
      });
    } catch (error) {
      throw error;
    }
  };

  _handleGeetestClose = () => {};

  _onChange = (event: Object, name: string, data: string) => {
    if (name === 'agreement') {
      const { checked } = event.target;
      isTrue('agreement', checked, this.props.i18n, msg => this.setState({ isAgreeError: msg, isAgree: checked })
      );
      return;
    }
    this.setState({
      [name]: data,
    });
  };

  _handlePwdChange = (v: string) => {
    this.setState({
      pwdLevel: checkPasswordLevel(v),
      password: v,
    });
  };

  _checkEmail = () => {
    const { email } = this.state;
    const { i18n } = this.props;
    let twoVerify = true;
    const result = checkInput('email', email, i18n, msg => {
      this.setState({ emailError: '' });
      if (msg) {
        this.setState({ emailError: msg });
      } else {
        const arr = this.state.forbidenEmails;
        for (let i = 0; i < arr.length; i++) {
          if (email.endsWith(arr[i])) {
            twoVerify = false;
            this.setState({ emailError: `${arr[i]} ${getLabel('exchange-register-whiteEmailAlert', i18n)}` });
          }
        }
      }
    });
    return (result === true && twoVerify === true);
  };

  _checkPassword = () => {
    const { password } = this.state;
    const { i18n } = this.props;
    const res = checkInput('password', password, i18n, msg => this.setState({ passwordError: msg, pwdLevel: '' })
    );
    if (!res) return false;
    this.setState({
      passwordError: '',
      pwdLevel: checkPasswordLevel(password),
    });
    return true;
  };

  _checkAgentId = () => {
    const { agentId } = this.state;
    // const { i18n } = this.props;
    // return checkAgentId(agentId, i18n, msg => this.setState({ agentIdError: msg }));
    const partten = regrex.userId;
    if (!is.empty(agentId) && partten.test(agentId)) {
      this.props.fetchUserAgentMessage({
        agentCode: agentId,
      });
    } else {
      // 先清除返佣数据
      this.props.fetchUserAgentMessage({
        agentCode: 0,
      });
    }
    return true;
  };

  _onSubmit = async (event: Object) => {
    event.preventDefault();
    const { isAgree } = this.state;
    const emailCheckResult = this._checkEmail();
    const passwordCheckResult = this._checkPassword();
    // const agentIdCheckResult = await this._checkAgentId();
    const agreementCheckResult = isTrue('agreement', isAgree, this.props.i18n, msg => this.setState({ isAgreeError: msg })
    );

    if (!emailCheckResult || !passwordCheckResult || !agreementCheckResult) {
      return;
    }
    this.mybot.sendCheckInfo && this.mybot.sendCheckInfo();
    this.state.capt.verify();
  };

  render() {
    const {
      locale, i18n, refSwitchInfo, referralRate,
    } = this.props;
    const { refSwitch } = refSwitchInfo;
    const {
      email,
      emailError,
      password,
      passwordError,
      agentId,
      agentIdError,
      isAgree,
      isAgreeError,
      submiting,
      isAgent,
      pwdLevel,
      loadingGeetest,
    } = this.state;
    const referralRateTips =
      referralRate !== '' &&
      `${getLabel('exchange-friends-receive', i18n)} ${Number(referralRate) * 100}%`;
    return (
      <FormBox>
        <GloablModalStyled />
        <AgentIdInfo callback={this._handleAgentIdInfo} />
        <AutoForm
          onChange={this._onChange}
          onSubmit={this._onSubmit}
          trim={true}
          autoComplete="off"
        >
          <FormItem>
            <InputShrink
              id="RegisterForm-input-email"
              type="text"
              name="email"
              value={email}
              placeholder={getLabel('exchange-register-email', i18n)}
              onChange={v => this.setState({ email: v.trim() })}
              onBlur={this._checkEmail}
              status={emailError && 'error'}
              help={emailError}
            />
          </FormItem>
          <FormItem>
            <FlexBox justify="flex-end">
              {pwdLevel && <Safety type={pwdLevel} locale={getCommonUiLocales(locale)} />}
            </FlexBox>
            <InputShrink
              id="RegisterForm-input-password"
              type="password"
              name="password"
              value={password}
              placeholder={getLabel('exchange-register-password', i18n)}
              onChange={this._handlePwdChange}
              onBlur={this._checkPassword}
              help={passwordError || getLabel('exchange-register-passwordConditions', i18n)}
              status={passwordError ? 'error' : 'info'}
            />
          </FormItem>
          {refSwitch && (
            <FormItem margin="0">
              <InputShrink
                id="RegisterForm-input-referralID"
                type="text"
                name="agentId"
                value={agentId}
                disabled={isAgent}
                placeholder={`${getLabel('exchange-register-referralID', i18n)}`}
                onBlur={this._checkAgentId}
                onChange={v => this.setState({ agentId: v })}
                status={agentIdError ? 'error' : 'info'}
                help={agentIdError || referralRateTips}
              />
            </FormItem>
          )}
          <StyledLabel>
            <Checkbox id="RegisterForm-input-agreement" name="agreement" checked={isAgree} />
            {`${getLabel('exchange-register-18YearsOld', i18n)} `}
            <a id="RegisterForm-a-termsOfUse" href={TERMS_URL.replace('%locale', locale)}>
              {getLabel('exchange-register-termsOfUse', i18n)}
            </a>
          </StyledLabel>
          <FormItemHelp isError={!!isAgreeError}>{isAgreeError}</FormItemHelp>
          <Button
            loading={submiting || loadingGeetest}
            size="lg"
            type="primary"
            block={true}
            disabled={submiting || loadingGeetest}
            id="RegisterForm-button-register"
          >
            {getLabel('exchange-register-createAccount', i18n)}
          </Button>
        </AutoForm>
        <SideBox justify="center" margin="40px 0 0">
          {getLabel('exchange-register-alreadyRegistered', i18n)}&nbsp;
          <a id="RegisterForm-a-login" href={this.loginUrl}>
            {getLabel('exchange-login-signIn', i18n)}
          </a>
        </SideBox>
        <GeeTest
          success={1}
          product="bind"
          lang={locale === 'cn' ? 'zh-cn' : 'en'}
          onReady={this._handleGeetestReady}
          onError={this._handleGeetestError}
          onSuccess={this._handlerGeetestSuccess}
          onClose={this._handleGeetestClose}
        />
      </FormBox>
    );
  }
}
